<script lang="ts">
  import { isLoggedInStore } from "../../stores";
  import { type TTheme } from "../../utils/types";
  import MenuItem from "./MenuItem.svelte";
  import ChevronUpIcon from "../images/chevron-up.svg";

  export let options: {
    onClick: () => void;
    title: string;
    passIcon: string;
    chevronStyles: string;
    isMinimized: boolean;
    theme: TTheme;
  };

  let { onClick, title, passIcon, theme } = options;

  $: chevronStyles = options.chevronStyles;
  $: isMinimized = options.isMinimized;
</script>

<MenuItem
  options={{
    title,
    onClick,
    isDisabled: false,
    isMinimized,
    theme,
    isMain: true,
  }}
>
  <div
    class={`crtw-flex crtw-justify-center crtw-items-center crtw-rounded-md`}
    slot="icon"
  >
    <img class="crtw-block crtw-max-w-[30px]" src={passIcon} alt="" />
  </div>
  {#if $isLoggedInStore}
    <img src={ChevronUpIcon} alt="" style={chevronStyles} />
  {/if}
</MenuItem>
